import "client-only"

import { CommunityProfileStatus } from "@/services/get-community-info-user-me"

export function buildAuthenticatedReservedAreaLink(
  reservedAreaLink: string,
  authToken: string,
) {
  const url = reservedAreaLink.startsWith("/")
    ? new URL(reservedAreaLink, window.location.origin)
    : new URL(reservedAreaLink)

  url.searchParams.set("auth-token", authToken)
  return url.toString()
}

export function isReservedAreaUrl(url: string) {
  return url.startsWith(window.APP_REDIRECT_AR)
}

export function isPortalUrl(url: string) {
  return url.startsWith(window.APP_MAIN_SITE_HOMEPAGE)
}

export function getAppLoginCallbackUrl(
  token: string,
  tokenTouch: string,
  flagConto?: number,
) {
  const sessionId = sessionStorage.getItem("session-id")

  const url = new URL("http://appmobile.sisal.it")
  const searchParams = new URLSearchParams()
  searchParams.set("auth-token", token)
  searchParams.set("jwtToken", tokenTouch)
  if (flagConto != null) {
    searchParams.set("flagConto", flagConto.toString())
  }
  if (sessionId != null) {
    searchParams.set("session-id", sessionId)
  }
  url.search = searchParams.toString()
  return url.toString()
}

export function buildCommunityRedirectUrl(
  communityProfileStatus: CommunityProfileStatus,
  communityShare?: string,
) {
  const portalUrl = new URL(window.APP_MAIN_SITE_HOMEPAGE)

  switch (communityProfileStatus) {
    case "HAS_COMMUNITY_PROFILE":
      if (communityShare) {
        portalUrl.pathname = `community/profili/${encodeURIComponent(communityShare)}`
        return portalUrl
      }
      portalUrl.pathname = "/community"
      return portalUrl
    case "NO_COMMUNITY_PROFILE":
      portalUrl.searchParams.set("community", "true")
      if (communityShare) {
        portalUrl.searchParams.set("communityShare", communityShare)
      }
      return portalUrl
    default:
      return portalUrl
  }
}
